import { useRecoilValue } from "recoil";
import { userState } from "store/store";

const useMaskUserId = () => {
  const user = useRecoilValue(userState);

  const maskUserId = (str?: string) => {
    if (!str) {
      return "";
    }
    if (user?.userId === str || [1, 2].includes(user?.grade?.id ?? 0)) {
      return str;
    }
    if (str.length <= 3) {
      return "***";
    }
    return str.slice(0, -3) + "***";
  };

  return maskUserId;
};

export default useMaskUserId;
